const EieAssetSecurityType = Object.assign({
  ISIN: { title: 'ISIN', value: 'isin' },
  LOAN: { title: 'Loan', value: 'loan' },
  TOKEN_SYMBOL: { title: 'Token', value: 'token_symbol' },
});

Object.freeze(EieAssetSecurityType);

export default EieAssetSecurityType;



// WEBPACK FOOTER //
// ./src/enum/eie/EieAssetSecurityType.js